<template>
    <b-sidebar id="add-new-holiday-sidebar" 
    :visible="isAddNewHolidaySidebarActive" 
    bg-variant="white" sidebar-class="sidebar-lg" 
    shadow 
    backdrop 
    no-header 
    right 
    @hidden="resetForm" 
    @change="(val) => $emit('update:is-add-new-holiday-sidebar-active', val)"
    >
        <template #default="{ hide }">
                  <!-- Header -->
                  <div
                    class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
                  >
                    <h5 class="mb-0">{{button_text}} Holiday</h5>
            
                    <feather-icon
                      class="ml-1 cursor-pointer"
                      icon="XIcon"
                      size="16"
                      @click="hide"
                    />
                  </div>
            
                  <!-- Body -->
                  <validation-observer 
                    #default="{ handleSubmit }"
                    ref="refFormObserver"
                  >
                  <b-overlay
                        :show = 'loading'
                        spinner-variant="primary"
                        spinner-type="grow"
                        spinner-small
                        rounded="sm"
                        >
                    <!-- Form -->
                    <b-form
                      class="p-2"
                      @submit.prevent="handleSubmit(onSubmit)"
                      @reset.prevent="resetForm"
                    >
                      <!-- Holiday Date-->
                      <validation-provider #default="validationContext" name="holiday_date" rules="required">
                          <b-form-group class="required" label="Holiday Date" label-for="holiday_date">
                              <b-form-datepicker id="holiday_date" :state="getValidationState(validationContext)" placeholder="Choose a date" local="en" v-model="holidayData.holiday_date" :date-format-options="{'year':'numeric','month':'numeric', 'day': 'numeric'}" />
                              <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                          </b-form-group>
                      </validation-provider>

                      <!-- Holiday Name -->
                      <validation-provider
                        #default="validationContext"
                        name="Holiday Name"
                        rules="required"
                      >
                        <b-form-group  class="required" label="Holiday Name" label-for="holiday_name">
                          <b-form-input
                            id="holiday_name"
                            v-model="holidayData.holiday_name"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Holiday Name"
                           />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                         
                        </b-form-group>
                      </validation-provider>
                                
                      <!-- Form Actions -->
                      
                      <div class="d-flex mt-2">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="mr-2"
                          type="submit"
                        >
                          {{button_text}}
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          type="button"
                          variant="outline-secondary"
                          @click="hide"
                        >
                          Cancel
                        </b-button>
                      </div>
                      
                    </b-form>
                    </b-overlay>
                  </validation-observer>
</template>
  </b-sidebar>
</template>

<script>
import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    BOverlay,
    BFormDatepicker,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { max } from "@/libs/validations.js"
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        BSidebar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BButton,
        BFormTextarea,
        BFormCheckbox,
        vSelect,
        BOverlay,
        BFormDatepicker,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: 'isAddNewHolidaySidebarActive',
        event: 'update:is-add-new-holiday-sidebar-active',
    },
    props: {
        isAddNewHolidaySidebarActive: {
            type: Boolean,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            required,
            alphaNum,
            email,
            max,
        }
    },
    setup(props, { emit }) {

        const loading = ref(false)

        const blankHolidayData = {
            id: 0,
            holiday_name: '',
            holiday_date: '',
        }
        const button_text = ref('Add')

        const holidayData = ref(JSON.parse(JSON.stringify(blankHolidayData)))

        const resetholidayData = () => {
            holidayData.value = JSON.parse(JSON.stringify(blankHolidayData))
        }

        const toast = useToast()

        watch(() => [props.id, props.isAddNewHolidaySidebarActive], () => {
            if (props.id > 0 && props.isAddNewHolidaySidebarActive) {
                holidayData.value.id = props.data.id
                holidayData.value.holiday_date = props.data.holiday_date
                holidayData.value.holiday_name = props.data.holiday_name
                if (holidayData.value.id > 0) {
                    button_text.value = 'Edit'
                } else {
                    button_text.value = 'Add'
                }
            } else {
                button_text.value = 'Add'
            }


        })

        const onSubmit = () => {
            loading.value = true
            store.dispatch("setting-holiday/addHoliday", holidayData.value)
                .then((response) => {
                    loading.value = false
                    emit("update:is-add-new-holiday-sidebar-active", false);
                    emit('refetch-data')
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Success',
                            text: response.data.message,
                            icon: 'CheckIcon',
                            variant: 'success'
                        }
                    })
                })
                .catch((error) => {
                    loading.value = false
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Fail',
                            text: error.response.data.message,
                            icon: 'HeartIcon',
                            variant: 'danger'
                        }
                    })
                })
        };

        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetholidayData)

        return {
            holidayData,
            onSubmit,
            refFormObserver,
            getValidationState,
            resetForm,
            button_text,
            loading,
        };


    }

};
</script>

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-holiday-sidebar {
    .vs__dropdown-menu {
        max-height: 200px !important;
    }
}
</style>